/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Refresh: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g clipPath='url(#clip0_20400_904)'>
      <path
        d='M23.216 9.21595L21.667 -0.0810547L18.469 3.11695C16.599 1.74995 14.356 0.999945 12 0.999945C5.935 0.999945 1 5.93495 1 11.9999C1 18.0649 5.935 22.9999 12 22.9999C16.374 22.9999 20.332 20.4099 22.084 16.4009C22.305 15.8949 22.074 15.3049 21.568 15.0839C21.063 14.8649 20.473 15.0939 20.251 15.5999C18.818 18.8799 15.579 20.9999 12 20.9999C7.038 20.9999 3 16.9619 3 11.9999C3 7.03795 7.038 2.99995 12 2.99995C13.821 2.99995 15.562 3.54395 17.039 4.54695L13.919 7.66694L23.216 9.21595Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_20400_904'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </React.Fragment>
)
